import { store } from '../../../../../../resources/frontend/js/store/index';
import { leadIsSent } from '@form/utils/send-lead';
import sbPopup from '../../../../mixins/utils/sb-popup';
import dataLayerPush from '../../../../mixins/utils/data-layer-push';

export const elmoCheck = data => {
    let postError = false;
    const postSuccess = data.success;
    const postReason = data.reason;
    let postValidated = data.response.validation.validated;
    const postErrors = data.response.validation?.failed || [];

    const onStepErrors = postErrors.filter(error => {
        return store.state.form.fields[store.state.form.attributes.step][error.input_key];
    });

    if (onStepErrors.length === 0) postValidated = true;

    // Check if the post is correct, not looking at if the data is correct
    if (postReason) {
        if (postSuccess === false && postReason !== 'DATA_INVALID') {
            postError = true;
        }
    }

    // Post is successful - Data is invalid
    if (postError === false && postValidated === false) {
        for (const postError of postErrors) {
            const name = postError['input_key'];
            store.commit('form/setFieldData', { name, key: 'validate', value: false });
            store.commit('form/setFieldData', { name, key: 'preValidate', value: false });
        }

        sbPopup(store.state.page.notificationText, 'error');
        store.commit('form/setAttribute', { key: 'loading', value: false });
    } else if (postError === false && postValidated === true) {
        const currentStep = store.state.form.attributes.step;
        const amountOfSteps = store.state.form.attributes.amountOfSteps;

        if (currentStep < amountOfSteps) {
            dataLayerPush(`Form step ${currentStep + 1}`);

            store.commit('form/setAttribute', { key: 'step', value: currentStep + 1 });
            store.commit('form/setAttribute', { key: 'loading', value: false });
            store.commit('page/increasePixelStep', { label: 'Form' });
        } else {
            dataLayerPush(`Form submit`);

            leadIsSent(data.response.eventId, true, data.sms_verification_sent);
        }
    } else {
        // If the Leadsystem doesn't response for instance
        alert('Something went wrong, please try again. (1)');
        store.commit('form/setAttribute', { key: 'loading', value: false });
    }
};
